
<div class="container-fluid" style=" padding-left: 0%; ">
	<div class="row">
		<div class="col-lg-3 col-md-4">
			<app-aside-nav></app-aside-nav>
		</div>
		<div class="col-lg-9 col-md-8">	
	<router-outlet></router-outlet>
</div>
	</div>
</div>